import React, { useEffect, useMemo } from "react";
import styles from "./MisProductos.module.scss";
import { connect } from "react-redux";
import {
    getPortfolio,
} from "../../../../store/actions/index";
import { motion } from "framer-motion";
import ProfileEmptyState from "../ProfileEmptyState/ProfileEmptyState.tsx";
import NuevoProducto from "./NuevoProducto/NuevoProducto.tsx";
import PortfolioCardWithLogic from "./PortfolioCardWithLogic.tsx";
import RegisteredUserProfileLoader from "../../../RegisteredUsers/RegisteredUsersSkeleton/RegisteredUserProfileLoader";


const MisProductos = ({
    portfolios,
    portfoliosLoading,
    perfilAjeno,
    getPortfolio,
    myPerson,
    userData,
    createNewPortfolio,
    handleNewPortfolioClick,
    setInfoReady,
    ...props
}) => {

    useEffect(() => {
        getPortfolio(perfilAjeno);
      }, [perfilAjeno, getPortfolio]);

      useEffect(() => {
        if (!portfoliosLoading && portfolios !== undefined) {
          setInfoReady(true);
        }
      }, [portfoliosLoading, portfolios, setInfoReady]);

    const sortedPortfolios = useMemo(() => {
        if (!portfolios || !Array.isArray(portfolios)) return [];
        return [...portfolios].sort((a, b) => {
            const dateA = new Date(a.createdAt || a.created_at || 0).getTime();
            const dateB = new Date(b.createdAt || b.created_at || 0).getTime();
            return dateB - dateA;
        });
    }, [portfolios]);

    return (
        <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className={styles.container}
        >
            {createNewPortfolio && (
                <NuevoProducto cancel={() => handleNewPortfolioClick(false)} />
            )}
            {portfoliosLoading ? (
                <div className={styles.loadingContainer}>
                    <RegisteredUserProfileLoader />
                </div>
            ) : (
                portfolios && portfolios.length > 0 ? (
                    <div className={styles.container_body}>
                        {sortedPortfolios.map((portfolio) => (
                            <PortfolioCardWithLogic
                                key={portfolio.id}
                                portfolio={portfolio}
                                myPerson={myPerson}
                                userData={userData}
                                currentTab={props.currentTab}
                            />
                        ))}
                    </div>
                ) : (
                    myPerson ? (
                        <ProfileEmptyState
                            illustration="products"
                            title="No tenés productos ni servicios publicados"
                            description="Creá tu primer ítem del catálogo para mostrarlo en el marketplace y en tu perfil."
                            onRootClick={handleNewPortfolioClick}
                        />
                    ) : (
                        <ProfileEmptyState
                            illustration="products"
                            title="Este perfil no tiene productos ni servicios publicados"
                            description="Cuando publique su catálogo en el marketplace, lo vas a ver acá."
                        />
                    )
                )
            )}
        </motion.section>
    );
};

const mapStateToProps = (state) => {
    return {
        portfolios: state.register.portfolios,
        portfoliosLoading: state.register.portfoliosLoading,
    };
};

export default connect(mapStateToProps, {
    getPortfolio,
})(MisProductos);